export default {
    requester_id: null,
    client_id: null,
}
